export default {
  install(Vue) {
    ;(Vue.prototype.$message = function(message) {
      this.$notify({
        verticalAlign: 'bottom',
        horizontalAlign: 'right',
        message,
        type: 'success',
        icon: 'check',
      })
    }),
      (Vue.prototype.$error = function(message) {
        this.$notify({
          verticalAlign: 'bottom',
          horizontalAlign: 'right',
          message,
          type: 'danger',
          icon: 'warning',
        })
      })
  },
}
